var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8582 7H11.5911C11.2199 7 10.9331 7.30368 10.9331 7.65797C10.9331 8.01226 11.2368 8.31594 11.5911 8.31594H19.8413C20.2125 8.31594 20.4993 8.01226 20.4993 7.65797C20.4993 7.30368 20.2125 7 19.8582 7Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7998 10.1387H11.5911C11.2199 10.1387 10.9331 10.4424 10.9331 10.7966C10.9331 11.1509 11.2368 11.4546 11.5911 11.4546H17.7998C18.171 11.4546 18.4578 11.1509 18.4578 10.7966C18.4578 10.4424 18.1541 10.1387 17.7998 10.1387Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7415 13.2598H11.5911C11.2199 13.2598 10.9331 13.5634 10.9331 13.9177C10.9331 14.272 11.2368 14.5757 11.5911 14.5757H15.7415C16.1127 14.5757 16.3995 14.272 16.3995 13.9177C16.3995 13.5634 16.1127 13.2598 15.7415 13.2598Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6832 16.3965H11.5911C11.2199 16.3965 10.9331 16.7002 10.9331 17.0545C10.9331 17.4087 11.2368 17.7124 11.5911 17.7124H13.6832C14.0543 17.7124 14.3412 17.4087 14.3412 17.0545C14.3412 16.7002 14.0543 16.3965 13.6832 16.3965Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55797 7.20347C7.30489 6.95041 6.88311 6.95041 6.61316 7.20347L4.6898 9.12677C4.43673 9.37984 4.43673 9.80161 4.6898 10.0716C4.94288 10.3246 5.36467 10.3246 5.63461 10.0716L6.42757 9.27861V17.0562C6.42757 17.4273 6.73126 17.7141 7.08556 17.7141C7.43987 17.7141 7.74355 17.4105 7.74355 17.0562V9.27861L8.53652 10.0716C8.67149 10.2065 8.8402 10.274 9.00892 10.274C9.17764 10.274 9.34635 10.2065 9.48132 10.0716C9.7344 9.81848 9.7344 9.39671 9.48132 9.12677L7.55797 7.20347Z",
    fill: "#6929E2",
    stroke: "#6929E2",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.56193df91af238f4d481b305f728aaac.svg";
export { ForwardRef as ReactComponent };